import type { Traveler } from "@b2bportal/traveler-api";
import { getDateTimeWithFormat } from "@hopper-b2b/utilities";
import dayjs from "dayjs";
import type { FlightMachineContext } from "@/modules/flight-checkout/types";

export const seatedInfantsNotAllowed = (ctx: Partial<FlightMachineContext>) => {
  const selectedFareId =
    ctx.flightShop?.selectedTrip?.returnFareId ||
    ctx.flightShop?.selectedTrip?.outgoingFareId;
  const fareDetails = ctx.flightShop?.tripDetails?.fareDetails;
  return fareDetails == null
    ? false
    : fareDetails
        .filter((fare) => fare.id === selectedFareId)
        .some((fare) => !!fare.excludeINS);
};

export const getIsLapInfant = (traveler: Traveler) => {
  const age = dayjs().diff(
    getDateTimeWithFormat(traveler.dateOfBirth, "YYYY-MM-DD"),
    "year"
  );
  return age < 2;
};
